import type { RouteRecordRaw } from 'vue-router';

import { UUID_REG_EXP_STR } from '@/core/lib/Uuid';
import { RouteName } from '@/core/router/RouteName';
import { Scope } from '@/plugins/authentication/lib/UserPermissions';

const routes: RouteRecordRaw[] = [
  {
    name: RouteName.UTILISATEURS_PARAMETRES,
    path: `/admin`,
    component: () => import('@/domains/utilisateurs/views/Utilisateurs/ParametresUtilisateursRootPage.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: RouteName.UTILISATEURS,
        path: `/admin/utilisateurs`,
        component: () =>
          import('@/domains/utilisateurs/views/Utilisateurs/ParametresUtilisateurs/UtilisateursPage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes: [Scope.UTILISATEURS_WRITE_ALL, Scope.UTILISATEURS_READ_ALL],
        },
      },
      {
        name: RouteName.COORDONNEES_PARTENAIRE,
        path: `/admin/informations-partenaires`,
        component: () =>
          import('@/domains/utilisateurs/views/Utilisateurs/ParametresUtilisateurs/CoordonneesPartenairePage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes: [Scope.DISTRIBUTEURS_READ_OWN],
        },
      },
    ],
  },
  {
    path: `/admin/utilisateurs/:id(${UUID_REG_EXP_STR})/modifier`,
    component: () =>
      import('@/domains/utilisateurs/views/Utilisateurs/UtilisateursSingle/UtilisateursSingleEditRootPage.vue'),
    meta: {
      requiresAuth: true,
      requiresScopes: [Scope.UTILISATEURS_WRITE_ALL, Scope.UTILISATEURS_READ_ALL],
    },
    props: true,
    children: [
      {
        name: RouteName.UTILISATEURS_SINGLE_EDIT,
        path: '',
        component: () =>
          import('@/domains/utilisateurs/views/Utilisateurs/UtilisateursSingle/UtilisateursSingleEditPage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes: [Scope.UTILISATEURS_WRITE_ALL, Scope.UTILISATEURS_READ_ALL],
        },
        props: true,
      },
      {
        name: RouteName.UTILISATEURS_SINGLE_EDIT_NOTIFICATIONS,
        path: 'notifications',
        component: () =>
          import(
            '@/domains/utilisateurs/views/Utilisateurs/UtilisateursSingle/UtilisateursSingleEditNotificationsPage.vue',
          ),
        meta: {
          requiresAuth: true,
          requiresScopes: [Scope.UTILISATEUR_PREFERENCES_READ_ALL, Scope.UTILISATEUR_PREFERENCES_WRITE_ALL],
        },
        props: true,
      },
    ],
  },
  {
    name: RouteName.UTILISATEURS_SINGLE_ADD,
    path: `/admin/utilisateurs/ajouter`,
    component: () =>
      import('@/domains/utilisateurs/views/Utilisateurs/UtilisateursSingle/UtilisateursSingleAddPage.vue'),
    meta: {
      requiresAuth: true,
      requiresScopes: [Scope.UTILISATEURS_WRITE_ALL, Scope.UTILISATEURS_READ_ALL],
    },
  },
  {
    name: RouteName.UTILISATEURS_SINGLE_ASSOCIER,
    path: `/admin/utilisateurs/associer`,
    component: () =>
      import('@/domains/utilisateurs/views/Utilisateurs/UtilisateursSingle/UtilisateursSingleAssocierPage.vue'),
    meta: {
      requiresAuth: true,
      requiresScopes: [Scope.UTILISATEURS_WRITE_ALL, Scope.UTILISATEURS_READ_ALL],
    },
  },
  {
    path: '/mon-compte',
    component: () => import('@/domains/utilisateurs/views/Compte/CompteRootPage.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: RouteName.COMPTE_EDIT,
        path: '',
        component: () => import('@/domains/utilisateurs/views/Compte/CompteEditPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: RouteName.COMPTE_EDIT_NOTIFICATIONS,
        path: 'notifications',
        component: () => import('@/domains/utilisateurs/views/Compte/CompteEditNotificationsPage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes: [Scope.UTILISATEUR_PREFERENCES_READ_OWN, Scope.UTILISATEUR_PREFERENCES_WRITE_OWN],
        },
      },
    ],
  },
];

export default routes;
